import React from 'react';
import { JobsTBDTypes, UserSegment } from '@fiverr-private/homepage_common_types';
import { BiEnrichment, DrawerBaseProps } from '@fiverr-private/jtbd_sdk';
import { logger } from '@fiverr-private/obs';
import { ResponsiveObject } from '@fiverr-private/theme/dist/esm/src/components/Box/types';
import { JobsTbdDrawerMapper } from '../../../lib/utils/jobsTBDMapper';
import { DrawerContextType } from '../../context/drawer/drawer.context';
import { metricsService } from '../../../utils/metrics';

export const openDrawerForPage = (
    drawerContext: DrawerContextType,
    jobType: JobsTBDTypes,
    biEnrichment: BiEnrichment | undefined,
    advancePage: () => void,
    drawerBaseProps: DrawerBaseProps
) => {
    const drawerImpl = JobsTbdDrawerMapper[jobType];

    if (drawerImpl) {
        const { setDrawerChildren, setDrawerSize, setDrawerCallbacks, openDrawer, closeDrawer } = drawerContext;
        const { DrawerComponent, drawerCallbacks, size } = drawerImpl;
        const { onDrawerOpen, onDrawerClose } = drawerCallbacks ?? {};

        setDrawerChildren(<DrawerComponent closeDrawer={closeDrawer} {...drawerBaseProps} />);
        setDrawerSize(size || 'md');
        setDrawerCallbacks({
            closeDrawerCallback: () => {
                onDrawerClose?.({ biEnrichment });
                advancePage();
            },
        });

        onDrawerOpen?.({ biEnrichment });
        openDrawer();
    }
};

export const sendGrafanaMetric = (jobType: JobsTBDTypes, metricType: string, buyerSegment?: UserSegment) => {
    try {
        metricsService.count(`jtbd.${metricType}.${jobType}.${buyerSegment?.buyerType}`);
    } catch (error: any) {
        logger.warn(error, { description: 'JTBD sendGrafanaMetric failed', jobType, buyerSegment });
    }
};

export const getCardStaticStyles = (jobMaxWidth: string): Record<string, ResponsiveObject<any>> => ({
    padding: '4',
    maxWidth: jobMaxWidth,
});
